import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api.ts'

export type PlausibilityCheckType =
  | 'user_count_vs_license'
  | 'asset_count_vs_position'
  | 'tier_jump_savings'
  | 'contract_expiring'
  | 'missing_party'
  | 'zero_quantity'

export type PlausibilitySeverity = 'info' | 'warning' | 'critical'

export interface PlausibilityFinding {
  type: PlausibilityCheckType
  severity: PlausibilitySeverity
  contractId: string
  contractNumber: string
  contractName: string | null
  contractItemId: string | null
  message: string
  details?: Record<string, unknown>
}

export interface PlausibilityResponse {
  total: number
  countsBySeverity: { critical: number; warning: number; info: number }
  findings: PlausibilityFinding[]
}

export function usePlausibilityFindings() {
  return useQuery<PlausibilityResponse>({
    queryKey: ['contracts', 'plausibility'],
    queryFn: () => apiClient.get('/contracts/plausibility').then((r) => r.data),
  })
}

export function useContractPlausibility(contractId: string | undefined) {
  return useQuery<{ findings: PlausibilityFinding[] }>({
    queryKey: ['contracts', 'plausibility', contractId],
    queryFn: () =>
      apiClient.get(`/contracts/${contractId}/plausibility`).then((r) => r.data),
    enabled: Boolean(contractId),
  })
}
